import { EMAIL_REGEX } from '@paragon/client-tools';
import { User } from '@paragon/contract-library';
import { notNullish } from '@paragon/utilities';

import { DraftUserRecord } from './CreateUser';

export function getAreAnyErrors(user: User) {
  const errors = [
    validate.organization(user.organization),
    validate.firstName(user.firstName),
    validate.lastName(user.lastName),
    validate.phone(user.phone),
    validate.location(user.location),
  ].filter(notNullish);
  return errors.length > 0;
}

export function getAreAnyErrorsForDraftUser(user: DraftUserRecord) {
  const errors = [
    validate.organization(user.organization),
    validate.firstName(user.firstName),
    validate.lastName(user.lastName),
    validate.phone(user.phone),
    validate.location(user.location),
  ].filter(notNullish);
  return errors.length > 0;
}

export const validate = {
  organization(value: string | null | undefined) {
    if (value == null || value.trim() === '') {
      return true;
    }

    return undefined;
  },

  email(value: string | null | undefined) {
    if (value == null || value.trim() === '') {
      return true;
    }

    if (!EMAIL_REGEX.test(value)) {
      return true;
    }

    return undefined;
  },

  firstName(value: string | null | undefined) {
    if (value == null || value.trim() === '') {
      return true;
    }

    return undefined;
  },

  lastName(value: string | null | undefined) {
    if (value == null || value.trim() === '') {
      return true;
    }

    return undefined;
  },

  phone(value: string | null | undefined) {
    if (value == null || value.trim() === '') {
      return true;
    }

    return undefined;
  },

  location(value: string | null | undefined) {
    if (value == null || value.trim() === 'No Location') {
      return true;
    }

    return undefined;
  },

  password(value: string | null | undefined) {
    if (value == null || value.trim() === '') {
      return true;
    }

    return undefined;
  },
};
